import { z } from '@bonanza-social/toolkit/api';

export const InitOnfidoSchema = z.object({
  sessionToken: z.string(),
  workflowRunId: z.string(),
});

export const ProcessOnfidoSchema = z.object({}).optional();
